<div class="comissao-etica-container">
    @if (carregando()) {
        <div class="feedback">Carregando dados da solicitação...</div>
    } @else if (erroConsulta()) {
        <div class="feedback feedback--erro">{{ erroConsulta() }}</div>
    } @else if (dados(); as dados) {
        @for (secao of secoes; track secao.titulo) {
            <app-card-content [headerColor]="false" [title]="secao.titulo" [icon]="iconeDaSecao(secao.titulo)" [subtitle]="subtituloDaSecao(secao.titulo)">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                    @for (campo of secao.campos; track campo.label) {
                        <div class="campo">
                            <span class="campo-label">{{ campo.label }}</span>
                            <strong class="campo-valor">{{ valorCampo(campo) }}</strong>
                        </div>
                    }
                </div>
            </app-card-content>
        }

        <app-card-content [headerColor]="false" [title]="'Documento'" [icon]="iconeDaSecao('Documento')" [subtitle]="subtituloDaSecao('Documento')">
            @if (possuiAnexo()) {
                <button type="button" class="campo-link-botao" (click)="onVisualizarAnexo($event)" aria-label="Visualizar anexo" title="Visualizar anexo">
                    <i class="pi pi-paperclip"></i>
                    <span>Visualizar anexo</span>
                </button>
            } @else {
                <span class="campo-valor">-</span>
            }
        </app-card-content>

        @if (prestadorDomain(); as prestadorDomain) {
            <app-card-content [headerColor]="false" [title]="'Composicao da Comissao de Etica'" [icon]="iconeDaSecao('Composicao da Comissao de Etica')" [subtitle]="subtituloDaSecao('Composicao da Comissao de Etica')">
                <app-comissao-etica-prestador [pessoa]="prestadorDomain"></app-comissao-etica-prestador>
            </app-card-content>
        }
    } @else {
        <div class="feedback">Selecione um protocolo para visualizar a solicitação.</div>
    }
</div>

<p-dialog
    appDialogoPadrao="pi pi-paperclip"
    descricao="Documento anexado ao registro."
    [visible]="exibirDialogAnexo()"
    (visibleChange)="exibirDialogAnexo.set($event)"
    [style]="{ width: '90vw', maxWidth: '1200px' }"
    header="Visualização de anexo"
    (onHide)="fecharDialogAnexo()"
>
    @if (blobAnexo(); as blobAnexo) {
        <app-visualizador-pdf [src]="blobAnexo" [fileName]="nomeArquivoAnexo()" [showAll]="false"></app-visualizador-pdf>
    } @else {
        <div class="feedback">Nenhum anexo disponível para visualização.</div>
    }
</p-dialog>
